import * as React from 'react';
import HyperLinkRenderer from 'components/common/DataGridDevEx/CustomRenderers/HyperLinkRenderer';

const HyperLinkCell = ({ data }) => (<HyperLinkRenderer value={{ SalesOrder: data.value, FieldValue: data.value }} colDef={{ headerName: 'Sales Order' }} link='sales-order-enquiry/order-details' />);

export default HyperLinkCell;
